import { api, ApiRequestConfig } from './api';
import { B2BOrganization } from 'types/b2b-organization';

const URL = 'b2b-organizations';

export const getB2BOrganizations = (config: ApiRequestConfig) =>
  api.get<B2BOrganization[]>(URL, undefined, config);
